(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9527,2803,5983,4131],{

/***/ 90290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _csc_dls__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37198);
/* harmony import */ var _LoadingModal_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55780);
/* harmony import */ var _LoadingModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_LoadingModal_module_scss__WEBPACK_IMPORTED_MODULE_3__);
// eslint-disable-next-line




var mobileLogoSvg = "https://assets.onekingslane.com/m/62954f1b3cd8439b/original/OKL2018_Elephant_K.png";
var ProgressingOutline = function(param) {
    var children = param.children, _mt = param.mt, mt = _mt === void 0 ? 6 : _mt;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "".concat((_LoadingModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().progressCircle), " mt-").concat(mt, " ml-auto mr-auto"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_LoadingModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().ring),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_LoadingModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().logo),
                children: children
            })
        ]
    });
};
var LogoWithProgressingOutline = function(param) {
    var _mt = param.mt, mt = _mt === void 0 ? 6 : _mt;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProgressingOutline, {
        mt: mt,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: mobileLogoSvg,
            alt: "OKL"
        })
    });
};
var LoadingModal = function(param) {
    var open = param.open, message = param.message, _hasLogo = param.hasLogo, hasLogo = _hasLogo === void 0 ? true : _hasLogo, _variant = param.variant, variant = _variant === void 0 ? "light" : _variant, _closeable = param.closeable, closeable = _closeable === void 0 ? false : _closeable, _loading = param.loading, loading = _loading === void 0 ? true : _loading, _onClose = param.onClose, onClose = _onClose === void 0 ? function() {} : _onClose;
    if (!open) {
        return null;
    }
    var loadingDisplay = function() {
        return hasLogo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LogoWithProgressingOutline, {
            mt: message ? 6 : 0
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProgressingOutline, {});
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_LoadingModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().overwriteModalZIndex),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_csc_dls__WEBPACK_IMPORTED_MODULE_2__/* .Modal */ .u_, {
            open: open,
            variant: variant,
            closeable: closeable,
            closeButton: closeable,
            onClose: onClose,
            children: open && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_csc_dls__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
                cols: 1,
                className: "p-6",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_csc_dls__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
                    children: [
                        !!message && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_csc_dls__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                            className: "text-center",
                            children: message
                        }),
                        loading && loadingDisplay()
                    ]
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (LoadingModal);


/***/ }),

/***/ 94131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);



var Modal = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(__webpack_require__.e(/* import() */ 8558).then(__webpack_require__.bind(__webpack_require__, 28558)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28558)
            ];
        }
    }
});
var ApplePayButtonUI = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(__webpack_require__.e(/* import() */ 1828).then(__webpack_require__.bind(__webpack_require__, 81828)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(81828)
            ];
        }
    }
});
var ApplePayNotAvailableModal = function(param) {
    var open = param.open, onClose = param.onClose, message = param.message;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Modal, {
        open: open,
        onClose: onClose,
        closeable: true,
        children: message
    });
};
var applePayDataTestId = function(key) {
    if (!key) {
        return "";
    }
    var dataTestIds = {
        miniCart: "apple-pay-mini-cart-cta",
        cart: "apple-pay-cart-cta",
        pdp: "apple-pay-pdp-cta"
    };
    var _key;
    return (_key = dataTestIds[key]) !== null && _key !== void 0 ? _key : "";
};
var applePayMessages = function(key) {
    if (!key) {
        return "";
    }
    var messages = {
        miniCart: "Check Out With",
        cart: "Check Out With",
        pdp: "Buy With"
    };
    var _key;
    return (_key = messages[key]) !== null && _key !== void 0 ? _key : "";
};
var ApplePayCTA = function(param) {
    var applePayExperience = param.applePayExperience, buttonHeightClassName = param.buttonHeightClassName, _theme = param.theme, theme = _theme === void 0 ? "white-with-line" : _theme, onStartCheckout = param.onStartCheckout, modalContent = param.modalContent, onCloseModal = param.onCloseModal, ctaRef = param.ctaRef, paymentMethod = param.paymentMethod;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ApplePayButtonUI, {
                theme: theme,
                ctaRef: ctaRef,
                onClick: onStartCheckout,
                message: applePayMessages(applePayExperience),
                buttonHeightClassName: buttonHeightClassName,
                dataTestId: applePayDataTestId(applePayExperience),
                paymentMethod: paymentMethod
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ApplePayNotAvailableModal, {
                open: !!modalContent,
                onClose: onCloseModal,
                message: modalContent
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ApplePayCTA);


/***/ }),

/***/ 27741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "OUT_OF_STOCK_MESSAGE": function() { return /* binding */ OUT_OF_STOCK_MESSAGE; },
  "default": function() { return /* binding */ Pdp_AddProductToCartForm; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./hooks/useIsExtendScriptLoaded.tsx
var useIsExtendScriptLoaded = __webpack_require__(28050);
// EXTERNAL MODULE: ./hooks/useProduct/index.tsx + 6 modules
var useProduct = __webpack_require__(41485);
// EXTERNAL MODULE: ./helpers/getOptimizeExperiment.ts
var getOptimizeExperiment = __webpack_require__(78184);
// EXTERNAL MODULE: ./services/Configuration.js
var Configuration = __webpack_require__(16977);
// EXTERNAL MODULE: ./services/Log.ts
var Log = __webpack_require__(27429);
;// CONCATENATED MODULE: ./hooks/useArrivalDateExperiment.ts




var useAdjustArrivalDate = function() {
    var ref = (0,react.useState)(false), shouldAdjustArrivalDate = ref[0], setShouldAdjustArrivalDate = ref[1];
    (0,react.useEffect)(function() {
        (0,getOptimizeExperiment/* getExperiment */.C2)({
            experimentId: Configuration.ARRIVAL_DATE_EXPERIMENT_ID
        }).then(function(variant) {
            if (variant === "1") {
                setShouldAdjustArrivalDate(true);
            }
        }).catch(Log/* error */.vU);
    }, []);
    return shouldAdjustArrivalDate;
};
/* harmony default export */ var useArrivalDateExperiment = (useAdjustArrivalDate);

// EXTERNAL MODULE: ./services/ExtendWarranty/index.js
var ExtendWarranty = __webpack_require__(94629);
// EXTERNAL MODULE: ./helpers/truthy.ts
var truthy = __webpack_require__(21681);
// EXTERNAL MODULE: ./helpers/allPromisesWithRetries.ts
var allPromisesWithRetries = __webpack_require__(48080);
// EXTERNAL MODULE: ./node_modules/@csc/dls/Row.js
var Row = __webpack_require__(69323);
// EXTERNAL MODULE: ./node_modules/@csc/dls/Col.js
var Col = __webpack_require__(79322);
// EXTERNAL MODULE: ./node_modules/@csc/dls/Text.js
var Text = __webpack_require__(45468);
// EXTERNAL MODULE: ./node_modules/@csc/dls/Link.js
var Link = __webpack_require__(97638);
// EXTERNAL MODULE: ./node_modules/@csc/dls/Heading3.js
var Heading3 = __webpack_require__(38732);
var Heading3_default = /*#__PURE__*/__webpack_require__.n(Heading3);
// EXTERNAL MODULE: ./components/ApplePay/ApplePayButton.tsx
var ApplePayButton = __webpack_require__(94131);
// EXTERNAL MODULE: ./hooks/useCanUseApplePay.ts + 2 modules
var useCanUseApplePay = __webpack_require__(64933);
// EXTERNAL MODULE: ./node_modules/@stripe/react-stripe-js/dist/react-stripe.umd.js
var react_stripe_umd = __webpack_require__(86664);
// EXTERNAL MODULE: ./services/ApplePay/transformers/transformOrderToApplePaySessionData.ts + 2 modules
var transformOrderToApplePaySessionData = __webpack_require__(60482);
// EXTERNAL MODULE: ./data/applePayMessages.ts
var applePayMessages = __webpack_require__(48142);
// EXTERNAL MODULE: ./services/Cart/getCart.ts
var getCart = __webpack_require__(36511);
// EXTERNAL MODULE: ./services/FramedCheckout/orderServices/getOrder.ts
var getOrder = __webpack_require__(86648);
// EXTERNAL MODULE: ./services/FramedCheckout/orderServices/recreateOrder.ts
var recreateOrder = __webpack_require__(72803);
// EXTERNAL MODULE: ./services/ApplePay/index.ts + 7 modules
var ApplePay = __webpack_require__(57781);
// EXTERNAL MODULE: ./helpers/isFeatureEnabled.ts
var isFeatureEnabled = __webpack_require__(965);
// EXTERNAL MODULE: ./services/ApplePay/Stripe/startStripeApplePaySession.ts + 5 modules
var startStripeApplePaySession = __webpack_require__(57238);
// EXTERNAL MODULE: ./components/ApplePay/applePayModalContentBuilder.tsx + 3 modules
var applePayModalContentBuilder = __webpack_require__(1070);
// EXTERNAL MODULE: ./helpers/GAEvents.tsx
var GAEvents = __webpack_require__(39933);
;// CONCATENATED MODULE: ./components/ApplePay/usePDPApplePayCheckout.ts















var isApplePayEnabled = function() {
    return (0,isFeatureEnabled/* isFeatureEnabled */.c)("applePayEnabled") && (0,isFeatureEnabled/* isFeatureEnabled */.c)("pdpApplePayCtaEnabled");
};
var prepareNewCheckoutForPDPItem = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
        var addProductFunction, initialCart, addPdpItemResponse, newOrder;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    addProductFunction = param.addProductFunction;
                    _ctx.next = 3;
                    return (0,getCart.getCart)();
                case 3:
                    initialCart = _ctx.sent;
                    if (!(initialCart && initialCart.id)) {
                        _ctx.next = 7;
                        break;
                    }
                    _ctx.next = 7;
                    return (0,recreateOrder.deleteCart)(initialCart.id);
                case 7:
                    _ctx.next = 9;
                    return addProductFunction();
                case 9:
                    addPdpItemResponse = _ctx.sent;
                    if (!(!addPdpItemResponse.success || !addPdpItemResponse.newCart)) {
                        _ctx.next = 12;
                        break;
                    }
                    throw new Error("Failed to add PDP item to cart");
                case 12:
                    _ctx.next = 14;
                    return (0,getOrder.getOrder)({
                        cart: addPdpItemResponse.newCart
                    });
                case 14:
                    newOrder = _ctx.sent;
                    return _ctx.abrupt("return", {
                        newOrder: newOrder,
                        initialCart: initialCart
                    });
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function prepareNewCheckoutForPDPItem(_) {
        return _ref.apply(this, arguments);
    };
}();
var recreateCart = function(param) {
    var setHasOngoingSession = param.setHasOngoingSession, setCart = param.setCart, prepNewSingleItemCheckoutPromise = param.prepNewSingleItemCheckoutPromise, completionHandlerCalled = param.completionHandlerCalled, setCompletionHandlerCalled = param.setCompletionHandlerCalled;
    return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var initialCart, currentCart, finalCart;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    (0,Log/* log */.cM)("recreateCart");
                    if (!completionHandlerCalled) {
                        _ctx.next = 5;
                        break;
                    }
                    (0,Log/* log */.cM)("skip recreateCart because it is invoked already");
                    return _ctx.abrupt("return");
                case 5:
                    setCompletionHandlerCalled(true);
                    _ctx.next = 8;
                    return prepNewSingleItemCheckoutPromise;
                case 8:
                    initialCart = _ctx.sent.initialCart;
                    (0,Log/* log */.cM)("recreateCart: prepNewSingleItemCheckoutPromise", {
                        initialCart: initialCart
                    });
                    _ctx.next = 12;
                    return (0,getCart.getCart)();
                case 12:
                    currentCart = _ctx.sent;
                    (0,Log/* log */.cM)("recreateCart: getCart", {
                        currentCart: currentCart
                    });
                    if (!(currentCart && currentCart.id)) {
                        _ctx.next = 17;
                        break;
                    }
                    _ctx.next = 17;
                    return (0,recreateOrder.deleteCart)(currentCart.id);
                case 17:
                    if (!initialCart) {
                        _ctx.next = 20;
                        break;
                    }
                    _ctx.next = 20;
                    return (0,recreateOrder.attemptToRecreateCart)(initialCart.lineItems);
                case 20:
                    _ctx.next = 25;
                    break;
                case 22:
                    _ctx.prev = 22;
                    _ctx.t0 = _ctx["catch"](0);
                    (0,Log/* error */.vU)("The PDP Failed to restore original cart: ".concat(String(_ctx.t0)), _ctx.t0);
                case 25:
                    _ctx.prev = 25;
                    setHasOngoingSession(false);
                    _ctx.next = 29;
                    return (0,getCart.getCart)();
                case 29:
                    finalCart = _ctx.sent;
                    setCart(finalCart);
                    (0,Log/* log */.cM)("recreateCart: finalCart", {
                        finalCart: finalCart
                    });
                    return _ctx.finish(25);
                case 33:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                22,
                25,
                33
            ]
        ]);
    }));
};
var startPdpApplePaySassionWithApple = function(param) {
    var prepNewSingleItemCheckoutPromise = param.prepNewSingleItemCheckoutPromise, beforeEnding = param.beforeEnding;
    return (0,ApplePay/* startSession */.y)({
        logPrefix: "Mini Cart ApplePay Session",
        initializationFunction: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return prepNewSingleItemCheckoutPromise;
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })),
        beforeAbort: beforeEnding,
        beforeRedirectOnSuccess: beforeEnding,
        initialPaymentRequest: (0,transformOrderToApplePaySessionData/* transformOrderToApplePaySessionData */.ry)({
            cart: {
                coupons: []
            },
            subtotal: 0,
            taxTotal: 0,
            totalDiscount: 0,
            shipments: [],
            grandTotal: 0
        })
    });
};
var usePDPApplePayCheckout = function(param) {
    var paymentRequest = param.paymentRequest, canUseApplePay = param.canUseApplePay, addProductFunction = param.addProductFunction, setCart = param.setCart, walletName = param.walletName, dispatchPaymentStatus = param.dispatchPaymentStatus;
    var stripe = (0,react_stripe_umd.useStripe)();
    var ctaRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(""), modalMessage = ref[0], setModalMessage = ref[1];
    var ref1 = (0,react.useState)(false), hasOngoingSession = ref1[0], setHasOngoingSession = ref1[1];
    var ref2 = (0,react.useState)(false), completionHandlerCalled = ref2[0], setCompletionHandlerCalled = ref2[1];
    var applePayModalContent = (0,react.useMemo)(function() {
        return (0,applePayModalContentBuilder/* default */.Z)(modalMessage);
    }, [
        modalMessage
    ]);
    var loadingModalTimeoutId = (0,react.useRef)(null);
    var startApplePaySession = (0,react.useCallback)(function() {
        if (isApplePayEnabled() && !hasOngoingSession) {
            dispatchPaymentStatus === null || dispatchPaymentStatus === void 0 ? void 0 : dispatchPaymentStatus({
                type: "start",
                error: null
            });
            if (loadingModalTimeoutId.current) {
                clearTimeout(loadingModalTimeoutId.current);
            }
            setHasOngoingSession(true);
            var prepNewSingleItemCheckoutPromise = prepareNewCheckoutForPDPItem({
                addProductFunction: addProductFunction
            });
            if ((0,isFeatureEnabled/* isFeatureEnabled */.c)("isStripeApplePayEnabled") && (0,isFeatureEnabled/* isFeatureEnabled */.c)("isStripePDPApplePayEnabled")) {
                setCompletionHandlerCalled(false);
                var completionHandler = recreateCart({
                    setCart: setCart,
                    setHasOngoingSession: setHasOngoingSession,
                    prepNewSingleItemCheckoutPromise: prepNewSingleItemCheckoutPromise,
                    completionHandlerCalled: completionHandlerCalled,
                    setCompletionHandlerCalled: setCompletionHandlerCalled
                });
                Promise.all([
                    (0,startStripeApplePaySession/* ApplePaySessionWithStripe */.h)({
                        stripe: stripe,
                        paymentRequest: paymentRequest,
                        sessionInitializationPromise: prepNewSingleItemCheckoutPromise,
                        beforeEnding: completionHandler,
                        onError: function() {
                            if (typeof dispatchPaymentStatus === "function") {
                                dispatchPaymentStatus({
                                    type: "fail",
                                    error: "Unable to process your request, please try again or with a different payment method"
                                });
                            }
                            return completionHandler();
                        },
                        walletName: walletName,
                        dispatchPaymentStatus: dispatchPaymentStatus
                    }), 
                ]).catch(function() {});
            } else {
                Promise.all([
                    startPdpApplePaySassionWithApple({
                        prepNewSingleItemCheckoutPromise: prepNewSingleItemCheckoutPromise,
                        beforeEnding: recreateCart({
                            setCart: setCart,
                            setHasOngoingSession: setHasOngoingSession,
                            prepNewSingleItemCheckoutPromise: prepNewSingleItemCheckoutPromise,
                            completionHandlerCalled: completionHandlerCalled,
                            setCompletionHandlerCalled: setCompletionHandlerCalled
                        })
                    }), 
                ]).catch(function() {
                    if (typeof dispatchPaymentStatus === "function") {
                        dispatchPaymentStatus({
                            type: "fail",
                            error: "Unable to process your request, please try again or with a different payment method"
                        });
                    }
                });
            }
        }
    }, [
        stripe,
        hasOngoingSession,
        addProductFunction,
        paymentRequest,
        setCart,
        walletName,
        dispatchPaymentStatus,
        completionHandlerCalled, 
    ]);
    var onStartCheckout = (0,react.useCallback)(function() {
        if (!canUseApplePay) {
            setModalMessage(applePayMessages/* applePayNotAvailableMessage */.k$);
        } else if (isApplePayEnabled()) {
            startApplePaySession();
            (0,GAEvents.pdpCheckoutEvent)(walletName);
        }
    }, [
        canUseApplePay,
        setModalMessage,
        startApplePaySession,
        walletName
    ]);
    return {
        onStartCheckout: onStartCheckout,
        modalContent: applePayModalContent,
        onCloseModal: function() {
            return setModalMessage("");
        },
        canUseApplePay: canUseApplePay,
        ctaRef: ctaRef
    };
};
/* harmony default export */ var ApplePay_usePDPApplePayCheckout = (usePDPApplePayCheckout);

// EXTERNAL MODULE: ./node_modules/@csc/dls/PrimaryButton.js
var PrimaryButton = __webpack_require__(10842);
// EXTERNAL MODULE: ./node_modules/@csc/dls/Quantity.js
var Quantity = __webpack_require__(1769);
// EXTERNAL MODULE: ./components/PaypalCTA/PaypalCtaWithLogic.tsx + 4 modules
var PaypalCtaWithLogic = __webpack_require__(84619);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./hooks/usePromise.ts
var usePromise = __webpack_require__(85549);
;// CONCATENATED MODULE: ./components/Checkout/usePDPCheckout.tsx










var usePDPCheckout_prepareNewCheckoutForPDPItem = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
        var addProductFunction, initialCart, addPdpItemResponse, newOrder;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    addProductFunction = param.addProductFunction;
                    _ctx.next = 3;
                    return (0,getCart.getCart)();
                case 3:
                    initialCart = _ctx.sent;
                    if (!(initialCart && initialCart.id)) {
                        _ctx.next = 7;
                        break;
                    }
                    _ctx.next = 7;
                    return (0,recreateOrder.deleteCart)(initialCart.id);
                case 7:
                    _ctx.next = 9;
                    return addProductFunction();
                case 9:
                    addPdpItemResponse = _ctx.sent;
                    if (!(!addPdpItemResponse.success || !addPdpItemResponse.newCart)) {
                        _ctx.next = 12;
                        break;
                    }
                    throw new Error("Failed to add PDP item to cart");
                case 12:
                    _ctx.next = 14;
                    return (0,getOrder.getOrder)({
                        cart: addPdpItemResponse.newCart
                    });
                case 14:
                    newOrder = _ctx.sent;
                    return _ctx.abrupt("return", {
                        newOrder: newOrder,
                        initialCart: initialCart
                    });
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function prepareNewCheckoutForPDPItem(_) {
        return _ref.apply(this, arguments);
    };
}();
var recreateInitialCartWith = function(initialCartPromise) {
    return function(setCart) {
        return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var initialCart, currentCart;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        (0,Log/* log */.cM)("recreateCart");
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return initialCartPromise;
                    case 4:
                        initialCart = _ctx.sent.initialCart;
                        (0,Log/* log */.cM)("recreateCart", {
                            initialCart: initialCart
                        });
                        _ctx.next = 8;
                        return (0,getCart.getCart)();
                    case 8:
                        currentCart = _ctx.sent;
                        (0,Log/* log */.cM)("recreateCart", {
                            currentCart: currentCart
                        });
                        if (!(currentCart && currentCart.id)) {
                            _ctx.next = 14;
                            break;
                        }
                        (0,Log/* log */.cM)("Deleting cart with id", currentCart.id);
                        _ctx.next = 14;
                        return (0,recreateOrder.deleteCart)(currentCart.id);
                    case 14:
                        if (!initialCart) {
                            _ctx.next = 18;
                            break;
                        }
                        (0,Log/* log */.cM)("Attempting to recreate cart", initialCart);
                        _ctx.next = 18;
                        return (0,recreateOrder.attemptToRecreateCart)(initialCart.lineItems);
                    case 18:
                        _ctx.next = 23;
                        break;
                    case 20:
                        _ctx.prev = 20;
                        _ctx.t0 = _ctx["catch"](1);
                        (0,Log/* error */.vU)("The PDP Failed to restore original cart: ".concat(String(_ctx.t0)), _ctx.t0);
                    case 23:
                        _ctx.prev = 23;
                        _ctx.t1 = setCart;
                        _ctx.next = 27;
                        return (0,getCart.getCart)();
                    case 27:
                        _ctx.t2 = _ctx.sent;
                        (0, _ctx.t1)(_ctx.t2);
                        return _ctx.finish(23);
                    case 30:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    20,
                    23,
                    30
                ]
            ]);
        }));
    };
};
var usePDPCheckout = function(param) {
    var addProductFunction = param.addProductFunction, setCart = param.setCart;
    var ref = (0,usePromise/* usePromise */.f)(), cartPrepPromise = ref.promise, resolvePrepPromise = ref.resolve, rejectPrepPromise = ref.reject;
    var onStartCheckout = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var prepNewSingleItemCheckoutPromise, newOrder;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    (0,Log/* log */.cM)("onStartCheckout", {
                        addProductFunction: addProductFunction,
                        rejectPrepPromise: rejectPrepPromise,
                        resolvePrepPromise: resolvePrepPromise
                    });
                    (0,GAEvents.pdpCheckoutEvent)("paypal");
                    if (!(!resolvePrepPromise || !rejectPrepPromise)) {
                        _ctx.next = 4;
                        break;
                    }
                    throw new Error("resolvePrepPromise or rejectPrepPromise not set");
                case 4:
                    prepNewSingleItemCheckoutPromise = usePDPCheckout_prepareNewCheckoutForPDPItem({
                        addProductFunction: addProductFunction
                    });
                    prepNewSingleItemCheckoutPromise.then(function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = arguments[_key];
                        }
                        Log/* log.apply */.cM.apply(void 0, [
                            "prepNewSingleItemCheckoutPromise resolved"
                        ].concat((0,_to_consumable_array/* default */.Z)(args)));
                        resolvePrepPromise.apply(void 0, (0,_to_consumable_array/* default */.Z)(args));
                    }).catch(rejectPrepPromise);
                    _ctx.next = 8;
                    return prepNewSingleItemCheckoutPromise;
                case 8:
                    newOrder = _ctx.sent.newOrder;
                    return _ctx.abrupt("return", newOrder.cart);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        addProductFunction,
        rejectPrepPromise,
        resolvePrepPromise
    ]);
    return {
        onStartCheckout: onStartCheckout,
        beforeAbort: recreateInitialCartWith(cartPrepPromise)(setCart)
    };
};
/* harmony default export */ var Checkout_usePDPCheckout = (usePDPCheckout);

// EXTERNAL MODULE: ./components/ScriptIntegrations/BloomreachEvents.tsx
var BloomreachEvents = __webpack_require__(70794);
// EXTERNAL MODULE: ./helpers/getVWOExperiment.ts
var getVWOExperiment = __webpack_require__(77836);
// EXTERNAL MODULE: ./hooks/useMobileDetect.tsx
var useMobileDetect = __webpack_require__(8497);
// EXTERNAL MODULE: ./components/Account/Payment/CardsModal/LoadingModal.tsx
var LoadingModal = __webpack_require__(90290);
;// CONCATENATED MODULE: ./hooks/usePaymentStatus.ts

var paymentInitialState = {
    status: "idle",
    error: null
};
var paymentReducer = function(state, action) {
    switch(action.type){
        case "start":
            return {
                status: "in progress",
                error: null
            };
        case "success":
            return {
                status: "success",
                error: null
            };
        case "fail":
            return {
                status: "failed",
                error: action.error
            };
        default:
            return {
                status: "idle",
                error: null
            };
    }
};
var usePaymentStatus = function() {
    var ref = (0,react.useReducer)(paymentReducer, paymentInitialState), paymentStatusState = ref[0], dispatchPaymentStatus = ref[1];
    var helpMessage = "";
    switch(paymentStatusState.status){
        case "in progress":
            helpMessage = "Processing your payment";
            break;
        case "failed":
            var _error;
            helpMessage = (_error = paymentStatusState.error) !== null && _error !== void 0 ? _error : "";
            break;
        default:
            helpMessage = "";
            break;
    }
    return {
        paymentStatus: paymentStatusState.status,
        dispatchPaymentStatus: dispatchPaymentStatus,
        helpMessage: helpMessage
    };
};

;// CONCATENATED MODULE: ./components/Pdp/AddProductToCartForm/index.tsx
































var EstimatedArrival = dynamic_default()(Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 78243)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(78243)
            ];
        }
    }
});
var shouldShowApplePayOnPDP = function() {
    return (0,isFeatureEnabled/* isFeatureEnabled */.c)("pdpApplePayCtaEnabled") && (0,isFeatureEnabled/* isFeatureEnabled */.c)("applePayEnabled");
};
var shouldShowPayPalOnPDP = function() {
    return (0,isFeatureEnabled/* isFeatureEnabled */.c)("pdpPayPalCtaEnabled") && (0,isFeatureEnabled/* isFeatureEnabled */.c)("payPalEnabled");
};
var OUT_OF_STOCK_MESSAGE = "Out of stock";
var AddProductToCartForm = function(param) {
    var setCart = param.setCart;
    var ref = usePaymentStatus(), paymentStatus = ref.paymentStatus, dispatchPaymentStatus = ref.dispatchPaymentStatus, helpMessage = ref.helpMessage;
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,react.useState)(1), quantity = ref2[0], setQuantity = ref2[1];
    var ref3 = (0,react.useState)(false), quantityError = ref3[0], setQuantityError = ref3[1];
    var ref4 = (0,useProduct.useProduct)(), product = ref4.product, sku = ref4.sku, warrantyVariant = ref4.warrantyVariant, addToCart = ref4.addToCart, inStock = ref4.inStock, selectedVariant = ref4.selectedVariant, user = ref4.user, inventoryLevel = ref4.inventoryLevel, isBackOrder = ref4.isBackOrder;
    var ref5 = (0,useCanUseApplePay/* default */.Z)({
        price: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.sale_price,
        paymentMethod: "applePay"
    }), canUseApplePay = ref5.canUseApplePay, paymentRequestApple = ref5.paymentRequest;
    var ref6 = (0,useCanUseApplePay/* default */.Z)({
        price: selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.sale_price,
        paymentMethod: "link"
    }), canUseLink = ref6.canUseApplePay, paymentRequestLink = ref6.paymentRequest;
    var extendScriptLoaded = (0,useIsExtendScriptLoaded/* useIsExtendScriptLoaded */.e)();
    var shouldAdjustArrivalDate = useArrivalDateExperiment();
    var handleAddToCart = function(shouldOfferExtendModal) {
        return function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(event) {
                var success, newCart, ref, ref1, ref2, ref3, ref4, ref5, name, category, result, ref6, ref7, trackAddToCart, ref8, addToCartConnexityEvent, ref9;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            success = false;
                            newCart = null;
                            _ctx.prev = 2;
                            ;
                            setIsLoading(true);
                            event === null || event === void 0 ? void 0 : (ref = event.preventDefault) === null || ref === void 0 ? void 0 : ref.call(event);
                            event === null || event === void 0 ? void 0 : (ref1 = event.stopPropagation) === null || ref1 === void 0 ? void 0 : ref1.call(event);
                            setQuantityError(!quantity);
                            if (quantity) {
                                _ctx.next = 10;
                                break;
                            }
                            return _ctx.abrupt("return", {
                                success: false,
                                newCart: null
                            });
                        case 10:
                            if (!(product && selectedVariant)) {
                                _ctx.next = 30;
                                break;
                            }
                            name = product.name, category = product.category_info;
                            _ctx.next = 14;
                            return addToCart(shouldOfferExtendModal)(quantity);
                        case 14:
                            result = _ctx.sent;
                            _ctx.t0 = _sliced_to_array/* default */.Z;
                            _ctx.next = 18;
                            return (0,allPromisesWithRetries/* default */.Z)(function() {
                                return [
                                    __webpack_require__.e(/* import() */ 8093).then(__webpack_require__.bind(__webpack_require__, 48093))
                                ];
                            });
                        case 18:
                            _ctx.t1 = _ctx.sent;
                            ref6 = (0, _ctx.t0)(_ctx.t1, 1);
                            ref7 = ref6[0];
                            trackAddToCart = ref7.default;
                            _ctx.t2 = _sliced_to_array/* default */.Z;
                            _ctx.next = 25;
                            return (0,allPromisesWithRetries/* default */.Z)(function() {
                                return [
                                    __webpack_require__.e(/* import() */ 1464).then(__webpack_require__.bind(__webpack_require__, 21464))
                                ];
                            });
                        case 25:
                            _ctx.t3 = _ctx.sent;
                            ref8 = (0, _ctx.t2)(_ctx.t3, 1);
                            addToCartConnexityEvent = ref8[0].addToCartConnexityEvent;
                            if (result.success && result.newCart) {
                                success = true;
                                newCart = result.newCart;
                            }
                            if (result.success) {
                                (0,allPromisesWithRetries/* default */.Z)(function() {
                                    return [
                                        Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 39933))
                                    ];
                                }).then(function(param) {
                                    var _param = (0,_sliced_to_array/* default */.Z)(param, 1), productGA = _param[0].productGA;
                                    var ref;
                                    return productGA({
                                        name: name,
                                        sku: sku,
                                        price: "".concat(selectedVariant.price || product.price),
                                        salePrice: selectedVariant.calculated_price,
                                        variantId: selectedVariant.id,
                                        categories: category,
                                        event: "addToCart",
                                        brand: product.brand,
                                        quantity: quantity,
                                        customerId: user === null || user === void 0 ? void 0 : user.entityId,
                                        customerEmail: user === null || user === void 0 ? void 0 : user.email,
                                        cartTotal: (result === null || result === void 0 ? void 0 : (ref = result.newCart) === null || ref === void 0 ? void 0 : ref.total) || 0
                                    });
                                }).catch(Log/* error */.vU);
                                try {
                                    ;
                                    trackAddToCart({
                                        name: name,
                                        sku: sku,
                                        price: selectedVariant.price || product.price,
                                        salePrice: selectedVariant.calculated_price,
                                        variantId: selectedVariant.id,
                                        categories: category,
                                        brand: product.brand,
                                        quantity: quantity,
                                        customerId: user === null || user === void 0 ? void 0 : user.entityId,
                                        customerEmail: user === null || user === void 0 ? void 0 : user.email,
                                        cartTotal: (result === null || result === void 0 ? void 0 : (ref9 = result.newCart) === null || ref9 === void 0 ? void 0 : ref9.total) || 0,
                                        backOrder: isBackOrder
                                    });
                                } catch (err) {
                                    (0,Log/* error */.vU)("Failed to log data in heap", err);
                                }
                                addToCartConnexityEvent(product);
                                (0,BloomreachEvents/* bloomreachAddToCartEvent */.PP)(selectedVariant.sku);
                            }
                        case 30:
                            window === null || window === void 0 ? void 0 : window.scrollTo({
                                top: 0,
                                behavior: "smooth"
                            });
                            (ref3 = (ref2 = document.getElementsByTagName) === null || ref2 === void 0 ? void 0 : ref2.call(document, "body")[0]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.classList) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.add) === null || ref5 === void 0 ? void 0 : ref5.call(ref4, "has-cart");
                            _ctx.next = 37;
                            break;
                        case 34:
                            _ctx.prev = 34;
                            _ctx.t4 = _ctx["catch"](2);
                            (0,Log/* error */.vU)("Failed to add to cart", _ctx.t4);
                        case 37:
                            _ctx.prev = 37;
                            setIsLoading(false);
                            return _ctx.finish(37);
                        case 40:
                            return _ctx.abrupt("return", {
                                success: success,
                                newCart: newCart
                            });
                        case 41:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        2,
                        34,
                        37,
                        40
                    ]
                ]);
            }));
            return function(event) {
                return _ref.apply(this, arguments);
            };
        }();
    };
    (0,react.useEffect)(function() {
        if (!extendScriptLoaded || !sku) {
            return;
        }
        // TODO: Kill this and move Extend offers to SSR
        ExtendWarranty.ExtendWarranty.initXPDP(sku);
    }, [
        sku,
        extendScriptLoaded
    ]);
    var quantityOptions = new Array(10).fill(0).map(function(a, b) {
        return b + 1;
    }).filter(function(i) {
        return !selectedVariant || inventoryLevel >= i;
    });
    var quantityOverflow = selectedVariant && inventoryLevel < quantity;
    var showNonReturnable = !(0,truthy.truthy)(warrantyVariant === null || warrantyVariant === void 0 ? void 0 : warrantyVariant.is_returnable);
    var ref7 = ApplePay_usePDPApplePayCheckout({
        paymentRequest: paymentRequestApple,
        canUseApplePay: canUseApplePay,
        addProductFunction: handleAddToCart(false),
        setCart: setCart,
        walletName: "applePay",
        dispatchPaymentStatus: dispatchPaymentStatus
    }), onStartCheckout = ref7.onStartCheckout, modalContent = ref7.modalContent, onCloseModal = ref7.onCloseModal, ctaRef = ref7.ctaRef;
    var ref8 = ApplePay_usePDPApplePayCheckout({
        paymentRequest: paymentRequestLink,
        canUseApplePay: canUseLink,
        addProductFunction: handleAddToCart(false),
        setCart: setCart,
        walletName: "link",
        dispatchPaymentStatus: dispatchPaymentStatus
    }), onStartCheckoutLink = ref8.onStartCheckout, modalContentLink = ref8.modalContent, onCloseModalLink = ref8.onCloseModal, ctaRefLink = ref8.ctaRef;
    var ref9 = Checkout_usePDPCheckout({
        setCart: setCart,
        addProductFunction: handleAddToCart(false)
    }), onPaypalCheckoutStart = ref9.onStartCheckout, recreateCart = ref9.beforeAbort;
    // TODO: Remove the useEffect and useState when the feature is fully rolled out
    // This might drop PDP CLS scores
    var isPayPalVisible = shouldShowPayPalOnPDP;
    var ref10 = (0,react.useState)(false), isApplePayVisible = ref10[0], setIsApplePayVisible = ref10[1];
    (0,react.useEffect)(function() {
        setIsApplePayVisible(shouldShowApplePayOnPDP() && canUseApplePay);
    }, [
        canUseApplePay
    ]);
    var isLinkExperimentOn = (0,getVWOExperiment.useGetExperiment)("linkPay");
    var isMobile = (0,useMobileDetect/* default */.Z)();
    var ref11 = (0,react.useState)(false), paymentOptionsExpanded = ref11[0], setPaymentOptionExpanded = ref11[1];
    var renderPaymentButtons = function() {
        if (isMobile && isApplePayVisible) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.ZP, {
                span: 12,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ApplePayButton["default"], {
                        applePayExperience: "pdp",
                        onStartCheckout: onStartCheckout,
                        modalContent: modalContent,
                        onCloseModal: onCloseModal,
                        ctaRef: ctaRef,
                        paymentMethod: "applePay"
                    }),
                    !paymentOptionsExpanded && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center gap-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            onClick: function() {
                                setPaymentOptionExpanded(function(prev) {
                                    return !prev;
                                });
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                bold: true,
                                size: "md",
                                className: "underline",
                                children: "More payment options"
                            })
                        })
                    }),
                    paymentOptionsExpanded && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.ZP, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.ZP, {
                                span: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaypalCtaWithLogic/* default */.Z, {
                                    forceReRender: [
                                        quantity
                                    ],
                                    onCancel: recreateCart,
                                    cartGenerator: onPaypalCheckoutStart,
                                    recreateCart: recreateCart
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.ZP, {
                                span: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ApplePayButton["default"], {
                                    onStartCheckout: onStartCheckoutLink,
                                    modalContent: modalContentLink,
                                    onCloseModal: onCloseModalLink,
                                    ctaRef: ctaRefLink,
                                    paymentMethod: "link"
                                })
                            })
                        ]
                    })
                ]
            });
        }
        var buttons = [
            isApplePayVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ApplePayButton["default"], {
                applePayExperience: "pdp",
                onStartCheckout: onStartCheckout,
                modalContent: modalContent,
                onCloseModal: onCloseModal,
                ctaRef: ctaRef,
                paymentMethod: "applePay"
            }) : null,
            isPayPalVisible() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PaypalCtaWithLogic/* default */.Z, {
                forceReRender: [
                    quantity
                ],
                onCancel: recreateCart,
                cartGenerator: onPaypalCheckoutStart,
                recreateCart: recreateCart
            }) : null,
            (0,isFeatureEnabled/* isFeatureEnabled */.c)("isLinkEnabled") && isLinkExperimentOn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ApplePayButton["default"], {
                onStartCheckout: onStartCheckoutLink,
                modalContent: modalContentLink,
                onCloseModal: onCloseModalLink,
                ctaRef: ctaRefLink,
                paymentMethod: "link"
            }) : null, 
        ];
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.ZP, {
            span: 12,
            "data-testid": "hi",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-between gap-2",
                children: buttons
            })
        });
    };
    if (!product) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        id: "add-to-cart-form",
        onSubmit: handleAddToCart(true),
        onChange: function() {},
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.ZP, {
                "data-testid": "submit-container",
                children: [
                    Configuration.ENABLE_EXTEND && /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.ZP, {
                        span: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "extend-offer",
                            "data-testid": "PDP_extend"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.ZP, {
                        span: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.ZP, {
                            gapY: "sm",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.ZP, {
                                    span: !isApplePayVisible && !isPayPalVisible() ? 12 : 3,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "h-full flex flex-row items-end",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Heading3_default()), {
                                            textTag: "p",
                                            children: "QTY:"
                                        })
                                    })
                                }),
                                !isLinkExperimentOn ? isApplePayVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.ZP, {
                                        span: 9,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ApplePayButton["default"], {
                                            applePayExperience: "pdp",
                                            onStartCheckout: onStartCheckout,
                                            modalContent: modalContent,
                                            onCloseModal: onCloseModal,
                                            ctaRef: ctaRef,
                                            paymentMethod: "applePay"
                                        })
                                    })
                                }) : isPayPalVisible() && /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.ZP, {
                                    className: "h-12 z-10",
                                    span: 9,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaypalCtaWithLogic/* default */.Z, {
                                        forceReRender: [
                                            quantity
                                        ],
                                        onCancel: recreateCart,
                                        cartGenerator: onPaypalCheckoutStart,
                                        recreateCart: recreateCart
                                    })
                                }) || null : /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.ZP, {
                                    span: 9
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.ZP, {
                                    span: 3,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Quantity["default"], {
                                        hideLabel: true,
                                        disabled: !inStock,
                                        id: "PDP_Quantity_Select",
                                        name: "qty",
                                        label: "qty",
                                        className: "",
                                        quantityWidth: "w-full",
                                        "data-quantity-change": true,
                                        value: !inStock ? 0 : quantity,
                                        onChange: setQuantity,
                                        options: quantityOptions
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.ZP, {
                                    span: 9,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.ZP, {
                                            cols: 2,
                                            children: [
                                                !isLinkExperimentOn ? isApplePayVisible && isPayPalVisible() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.ZP, {
                                                    className: "h-12 z-10 max-w-full",
                                                    span: {
                                                        sm: 2,
                                                        md: 1
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaypalCtaWithLogic/* default */.Z, {
                                                        forceReRender: [
                                                            quantity
                                                        ],
                                                        onCancel: recreateCart,
                                                        recreateCart: recreateCart,
                                                        cartGenerator: onPaypalCheckoutStart
                                                    })
                                                }) : null : null,
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.ZP, {
                                                    span: isLinkExperimentOn ? 2 : isApplePayVisible && isPayPalVisible() ? {
                                                        sm: 2,
                                                        md: 1
                                                    } : 2,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton["default"], {
                                                        id: "form-action-addToCart",
                                                        "data-button-type": "add-cart",
                                                        htmlType: "submit",
                                                        type: quantityOverflow || !inStock ? "disabled" : "primary",
                                                        disabled: quantityOverflow || !inStock,
                                                        className: "relative max-h-12",
                                                        "data-testid": "product-action-addToCart",
                                                        children: isLoading ? "... Adding to cart" : "ADD TO CART"
                                                    })
                                                })
                                            ]
                                        }),
                                        !isLinkExperimentOn && /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.ZP, {
                                            cols: 6,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.ZP, {
                                                span: 6,
                                                children: (0,isFeatureEnabled/* isFeatureEnabled */.c)("isLinkEnabled") && isLinkExperimentOn && /*#__PURE__*/ (0,jsx_runtime.jsx)(ApplePayButton["default"], {
                                                    applePayExperience: "pdp",
                                                    onStartCheckout: onStartCheckoutLink,
                                                    modalContent: modalContentLink,
                                                    onCloseModal: onCloseModalLink,
                                                    ctaRef: ctaRefLink,
                                                    paymentMethod: "link"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                isLinkExperimentOn && renderPaymentButtons(),
                                quantityOverflow && inStock ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.ZP, {
                                    span: 12,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.ZP, {
                                        size: "sm",
                                        bold: true,
                                        className: "text-error w-full text-left",
                                        children: [
                                            "Limited Quantity -",
                                            inventoryLevel,
                                            " ",
                                            "left"
                                        ]
                                    })
                                }) : inStock && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        !isBackOrder && /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.ZP, {
                                            span: 4
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.ZP, {
                                            span: isBackOrder ? 12 : 8,
                                            id: "EstimatedArrival",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EstimatedArrival, {
                                                variant: warrantyVariant,
                                                finalDateOffset: shouldAdjustArrivalDate ? 5 : 0
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    showNonReturnable && /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.ZP, {
                        span: 12,
                        className: "py-2 md:py-1 px-2 text-center",
                        style: {
                            backgroundColor: "#FBFBEF"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full flex-row items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.ZP, {
                                    className: "inline-block",
                                    size: "sm",
                                    children: [
                                        "This item is non-returnable.",
                                        " ",
                                        "See our"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                    size: "sm",
                                    className: "inline-block mx-0.5",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.ZP, {
                                        target: "_blank",
                                        href: "/faq/#returns-exchange",
                                        className: "inline-block",
                                        "aria-label": "Return Policy Page",
                                        children: "Return Policy"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                    className: "inline-block",
                                    size: "sm",
                                    children: "for details."
                                })
                            ]
                        })
                    })
                ]
            }),
            quantityError && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "out-of-stock-alert",
                children: "Please enter valid quantity"
            }),
            quantityError && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.ZP, {
                className: "text-error",
                id: "pdp-productstock-modal",
                children: [
                    "Sorry, we do not have enough stock on hand for the",
                    "quantity you've selected. Please try again."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingModal["default"], {
                open: paymentStatus !== "idle",
                message: helpMessage,
                closeable: true,
                loading: paymentStatus === "in progress",
                onClose: function() {
                    dispatchPaymentStatus({
                        type: "reset",
                        error: null
                    });
                }
            })
        ]
    });
};
/* harmony default export */ var Pdp_AddProductToCartForm = (AddProductToCartForm);


/***/ }),

/***/ 28050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ useIsExtendScriptLoaded; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _services_Configuration__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16977);
/* harmony import */ var _services_Configuration__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_services_Configuration__WEBPACK_IMPORTED_MODULE_1__);


var useIsExtendScriptLoaded = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), addonLoaded = ref[0], setAddonLoaded = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), clientLoaded = ref1[0], setClientLoaded = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), loaded = ref2[0], setLoaded = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (window.Extend) {
            setClientLoaded(true);
            return function() {};
        }
        var clientLoadedSetter = function() {
            return setClientLoaded(true);
        };
        document.addEventListener("ExtendClientLoaded", clientLoadedSetter);
        return function() {
            return document.removeEventListener("ExtendClientLoaded", clientLoadedSetter);
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (window.ExtendBigCommerce) {
            setAddonLoaded(true);
            return function() {};
        }
        var addonLoadedSetter = function() {
            return setAddonLoaded(true);
        };
        document.addEventListener("ExtendBigcommerceAddonLoaded", addonLoadedSetter);
        return function() {
            return document.removeEventListener("ExtendBigcommerceAddonLoaded", addonLoadedSetter);
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!addonLoaded || !clientLoaded) {
            return;
        }
        window.Extend.config({
            storeId: _services_Configuration__WEBPACK_IMPORTED_MODULE_1__.EXTEND_ID,
            environment: _services_Configuration__WEBPACK_IMPORTED_MODULE_1__.EXTEND_ENVIRONMENT
        });
        setLoaded(true);
    }, [
        addonLoaded,
        clientLoaded
    ]);
    return loaded;
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (useIsExtendScriptLoaded)));


/***/ }),

/***/ 25720:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29815);
/* harmony import */ var _codebuild_output_src3265067168_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src3265067168_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src3265067168_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48080);
/* harmony import */ var _Log__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27429);






var withExtendWarrantyNormalization = function(operator) {
    return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_codebuild_output_src3265067168_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var _len, args, _key, ref, getCart, checkIsExtendItem, EXTEND_SKU, rawCartDeleteItem, rawCartUpdateQuantity, cartOperationResult, getExtendingSku, extendWarrantyItems, sumQuantitiesWithSku, shouldBeUpdated, idsToAlsoApllyOperator, cartId, promises, lastCart, _args = arguments;
        return _codebuild_output_src3265067168_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    for(_len = _args.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = _args[_key];
                    }
                    _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z;
                    _ctx.next = 4;
                    return (0,_helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
                        return [
                            __webpack_require__.e(/* import() */ 6511).then(__webpack_require__.bind(__webpack_require__, 36511)),
                            __webpack_require__.e(/* import() */ 136).then(__webpack_require__.bind(__webpack_require__, 40136)),
                            Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 84749)),
                            __webpack_require__.e(/* import() */ 7012).then(__webpack_require__.bind(__webpack_require__, 87012)),
                            __webpack_require__.e(/* import() */ 1365).then(__webpack_require__.bind(__webpack_require__, 11365)), 
                        ];
                    });
                case 4:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 5);
                    getCart = ref[0].getCart;
                    checkIsExtendItem = ref[1].checkIsExtendItem;
                    EXTEND_SKU = ref[2].EXTEND_SKU;
                    rawCartDeleteItem = ref[3].rawCartDeleteItem;
                    rawCartUpdateQuantity = ref[4].rawCartUpdateQuantity;
                    _ctx.prev = 11;
                    _ctx.next = 14;
                    return operator.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(args));
                case 14:
                    cartOperationResult = _ctx.sent;
                    if (!(!cartOperationResult.success || !cartOperationResult.newCart)) {
                        _ctx.next = 17;
                        break;
                    }
                    return _ctx.abrupt("return", cartOperationResult);
                case 17:
                    getExtendingSku = function(sku) {
                        return checkIsExtendItem({
                            sku: sku
                        }) ? sku.split(EXTEND_SKU)[1] : "";
                    };
                    extendWarrantyItems = cartOperationResult.newCart.lineItems.filter(checkIsExtendItem);
                    sumQuantitiesWithSku = function(target) {
                        var ref;
                        return ((ref = cartOperationResult.newCart) === null || ref === void 0 ? void 0 : ref.lineItems.reduce(function(acc, param) {
                            var sku = param.sku, quantity = param.quantity;
                            return sku === target ? acc + quantity : acc;
                        }, 0)) || 0;
                    };
                    shouldBeUpdated = function(x) {
                        return !!x;
                    };
                    idsToAlsoApllyOperator = extendWarrantyItems.map(function(item) {
                        var expectedquantity = sumQuantitiesWithSku(getExtendingSku(item.sku));
                        if (expectedquantity !== item.quantity) {
                            return [
                                item.id,
                                expectedquantity
                            ];
                        }
                        return null;
                    }).filter(shouldBeUpdated);
                    if (idsToAlsoApllyOperator.length) {
                        _ctx.next = 24;
                        break;
                    }
                    return _ctx.abrupt("return", cartOperationResult);
                case 24:
                    cartId = cartOperationResult.newCart.id;
                    _ctx.next = 27;
                    return Promise.all(idsToAlsoApllyOperator.map(function(param) {
                        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(param, 2), itemId = _param[0], quantity = _param[1];
                        return quantity > 0 ? rawCartUpdateQuantity({
                            cartId: cartId,
                            itemId: itemId,
                            quantity: quantity
                        }) : rawCartDeleteItem({
                            cartId: cartId,
                            itemId: itemId
                        });
                    }));
                case 27:
                    promises = _ctx.sent;
                    lastCart = promises.sort(function(param, param1) {
                        var cartA = param.newCart, cartB = param1.newCart;
                        if (cartA && !cartB) {
                            return 1;
                        }
                        if (!cartA && cartB) {
                            return -1;
                        }
                        if (cartA && cartB) {
                            return new Date(cartA.updatedTime) > new Date(cartB.updatedTime) ? 1 : -1;
                        }
                        return 0;
                    })[0];
                    return _ctx.abrupt("return", {
                        success: true,
                        newCart: lastCart.newCart
                    });
                case 32:
                    _ctx.prev = 32;
                    _ctx.t2 = _ctx["catch"](11);
                    (0,_Log__WEBPACK_IMPORTED_MODULE_2__/* .error */ .vU)("Failed to Normalize cart with Extend");
                case 35:
                    _ctx.next = 37;
                    return getCart();
                case 37:
                    _ctx.t3 = _ctx.sent;
                    return _ctx.abrupt("return", {
                        success: false,
                        newCart: _ctx.t3
                    });
                case 39:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                11,
                32
            ]
        ]);
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (withExtendWarrantyNormalization);


/***/ }),

/***/ 15983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "getCartFromExtendInterface": function() { return /* binding */ getCartFromExtendInterface; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _codebuild_output_src3265067168_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src3265067168_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src3265067168_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);


var getCartFromExtendInterface = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_codebuild_output_src3265067168_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _codebuild_output_src3265067168_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(!window.Extend || !window.ExtendBigCommerce)) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return", null);
                case 2:
                    return _ctx.abrupt("return", new Promise(function(resolve, reject) {
                        window.ExtendBigCommerce.getCart(function(error, cart) {
                            return error ? reject(error) : resolve(cart);
                        });
                    }));
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getCartFromExtendInterface() {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["default"] = (getCartFromExtendInterface);


/***/ }),

/***/ 94629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ExtendWarranty": function() { return /* binding */ ExtendWarranty; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _codebuild_output_src3265067168_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src3265067168_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src3265067168_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _getCart__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15983);
/* harmony import */ var _openModal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31433);




var ExtendWarranty = {
    initXPDP: function initXPDP(productSku) {
        window.ExtendWarrantyService = ExtendWarranty;
        // Add timeout to ensure add to cart button has finished rendering
        this.productOptionsElement = document.querySelector("#add-to-cart-form .product-options");
        this.addToCartButton = document.querySelector("#form-action-addToCart");
        window.Extend.buttons.destroyAll();
        window.Extend.buttons.render("#extend-offer", {
            referenceId: productSku
        });
        var url = new URL(window.location.href);
        if (url.searchParams.get("sku")) {
            this.processVariant(url.searchParams.get("sku"));
        }
    },
    processVariant: function processVariant(sku) {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_codebuild_output_src3265067168_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, ref1;
            return _codebuild_output_src3265067168_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        (ref1 = (ref = window.Extend) === null || ref === void 0 ? void 0 : ref.buttons.instance("#extend-offer")) === null || ref1 === void 0 ? void 0 : ref1.setActiveProduct(sku);
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    },
    getCart: _getCart__WEBPACK_IMPORTED_MODULE_1__["default"],
    openModal: _openModal__WEBPACK_IMPORTED_MODULE_2__["default"],
    getOffer: function getOffer(sku) {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_codebuild_output_src3265067168_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _codebuild_output_src3265067168_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", window.Extend.getOffer(sku));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    },
    isExtendProduct: function isExtendProduct(sku) {
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_codebuild_output_src3265067168_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var offer;
            return _codebuild_output_src3265067168_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return window.Extend.getOffer(sku);
                    case 2:
                        offer = _ctx.sent;
                        return _ctx.abrupt("return", Boolean(offer.product.title));
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    },
    createCartWithProduct: function createCartWithProduct(productId) {
        var data = JSON.stringify({
            action: "add",
            product_id: productId,
            "qty[]": 1
        });
        return new Promise(function(resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.withCredentials = true;
            xhr.addEventListener("readystatechange", function() {
                if (this.readyState === this.DONE) {
                    resolve({
                        status: xhr.status,
                        data: xhr.response
                    });
                }
            });
            xhr.addEventListener("error", function(event) {
                reject(event);
            });
            // TODO: Migrate to V3
            xhr.open("POST", "remote/v1/cart/add");
            xhr.setRequestHeader("content-type", "application/json");
            xhr.responseType = "json";
            xhr.send(data);
        });
    },
    initXMiniCart: function initXMiniCart() {
        if (window.Extend && window.ExtendBigCommerce) {
            window.ExtendBigCommerce.getCart(function(error, cart) {
                if (cart) {
                    window.ExtendBigCommerce.normalizeCart({
                        cart: cart,
                        balance: true
                    }, function() {});
                }
            });
        }
    },
    extendCatalogOffers: function extendCatalogOffers(cartUrl) {
        if (window.Extend && window.ExtendBigCommerce) {
            document.querySelector('[data-button-type="add-cart"]').on("click", function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                var sku = e.currentTarget.getAttribute("data-product-sku");
                var productId = e.currentTarget.getAttribute("data-product-id");
                var href = e.currentTarget.getAttribute("href");
                window.ExtendBigCommerce.getCart(function(_, cart) {
                    if (cart) {
                        window.Extend.modal.open({
                            referenceId: sku,
                            onClose: function(plan, product) {
                                if (plan && product) {
                                    window.ExtendBigCommerce.addPlanToCart({
                                        sku: sku,
                                        plan: plan,
                                        cart: cart
                                    }, function() {
                                        window.location = href;
                                    });
                                } else {
                                    window.location = href;
                                }
                            }
                        });
                    } else {
                        ExtendWarranty.createCartWithProduct(productId).then(function(res) {
                            if (!res.data) {
                                window.location = cartUrl;
                                return;
                            }
                            window.Extend.modal.open({
                                referenceId: sku,
                                onClose: function(plan, product) {
                                    if (plan && product) {
                                        window.ExtendBigCommerce.addPlanToCart({
                                            sku: sku,
                                            plan: plan
                                        }, function() {
                                            window.location = cartUrl;
                                        });
                                    } else {
                                        window.location = cartUrl;
                                    }
                                }
                            });
                        });
                    }
                });
            });
        }
    }
};
/* harmony default export */ __webpack_exports__["default"] = (ExtendWarranty);


/***/ }),

/***/ 31433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "openExtendWarrantyModal": function() { return /* binding */ openExtendWarrantyModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _codebuild_output_src3265067168_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src3265067168_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src3265067168_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Cart_getCart__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36511);
/* harmony import */ var _Cart_withExtendWarrantyNormalization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25720);
/* harmony import */ var _getCart__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15983);





var rawOpenExtendWarrantyModal = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_codebuild_output_src3265067168_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var sku, quantity, cart;
        return _codebuild_output_src3265067168_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    sku = param.sku, quantity = param.quantity;
                    _ctx.next = 3;
                    return (0,_getCart__WEBPACK_IMPORTED_MODULE_3__.getCartFromExtendInterface)();
                case 3:
                    cart = _ctx.sent;
                    return _ctx.abrupt("return", new Promise(function(resolve) {
                        window.Extend.modal.open({
                            referenceId: sku,
                            onClose: function(plan) {
                                window.ExtendBigCommerce.addPlanToCart({
                                    sku: sku,
                                    plan: plan,
                                    quantity: quantity,
                                    cart: cart
                                }, function() {
                                    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_codebuild_output_src3265067168_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(error) {
                                        return _codebuild_output_src3265067168_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                            while(1)switch(_ctx.prev = _ctx.next){
                                                case 0:
                                                    if (!error) {
                                                        _ctx.next = 9;
                                                        break;
                                                    }
                                                    _ctx.t1 = resolve;
                                                    _ctx.next = 4;
                                                    return (0,_Cart_getCart__WEBPACK_IMPORTED_MODULE_1__.getCart)();
                                                case 4:
                                                    _ctx.t2 = _ctx.sent;
                                                    _ctx.t3 = {
                                                        success: false,
                                                        newCart: _ctx.t2
                                                    };
                                                    _ctx.t0 = (0, _ctx.t1)(_ctx.t3);
                                                    _ctx.next = 15;
                                                    break;
                                                case 9:
                                                    _ctx.t4 = resolve;
                                                    _ctx.next = 12;
                                                    return (0,_Cart_getCart__WEBPACK_IMPORTED_MODULE_1__.getCart)();
                                                case 12:
                                                    _ctx.t5 = _ctx.sent;
                                                    _ctx.t6 = {
                                                        success: true,
                                                        newCart: _ctx.t5
                                                    };
                                                    _ctx.t0 = (0, _ctx.t4)(_ctx.t6);
                                                case 15:
                                                    return _ctx.abrupt("return", _ctx.t0);
                                                case 16:
                                                case "end":
                                                    return _ctx.stop();
                                            }
                                        }, _callee);
                                    }));
                                    return function(error) {
                                        return _ref.apply(this, arguments);
                                    };
                                }());
                            }
                        });
                    }));
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function rawOpenExtendWarrantyModal(_) {
        return _ref.apply(this, arguments);
    };
}();
var openExtendWarrantyModal = (0,_Cart_withExtendWarrantyNormalization__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(rawOpenExtendWarrantyModal);
/* harmony default export */ __webpack_exports__["default"] = (openExtendWarrantyModal);


/***/ }),

/***/ 72803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "addSingleLineItemToCart": function() { return /* binding */ addSingleLineItemToCart; },
/* harmony export */   "attemptToRecreateCart": function() { return /* binding */ attemptToRecreateCart; },
/* harmony export */   "createCartWithSingleLineItem": function() { return /* binding */ createCartWithSingleLineItem; },
/* harmony export */   "deleteCart": function() { return /* binding */ deleteCart; },
/* harmony export */   "recreateOrder": function() { return /* binding */ recreateOrder; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(29815);
/* harmony import */ var _codebuild_output_src3265067168_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src3265067168_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src3265067168_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _services_Log__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27429);
/* harmony import */ var _types_BigCommerce_BCCart__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6888);
/* harmony import */ var _types_BigCommerce_BCCheckout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10182);
/* harmony import */ var _helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48080);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_5__);









var deleteCart = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_codebuild_output_src3265067168_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(cartId) {
        return _codebuild_output_src3265067168_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return axios__WEBPACK_IMPORTED_MODULE_5___default()["delete"]("/api/storefront/carts/".concat(cartId));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function deleteCart(cartId) {
        return _ref.apply(this, arguments);
    };
}();
var addSingleLineItemToCart = function(cartId) {
    return function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_codebuild_output_src3265067168_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(lineItem) {
            var response, cart;
            return _codebuild_output_src3265067168_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return axios__WEBPACK_IMPORTED_MODULE_5___default().post("/api/storefront/carts/".concat(cartId, "/items?include=lineItems.physicalItems.options"), {
                            lineItems: [
                                {
                                    productId: lineItem.productId,
                                    quantity: lineItem.quantity,
                                    variantId: lineItem.variantId
                                }, 
                            ]
                        });
                    case 3:
                        response = _ctx.sent;
                        cart = response.data;
                        (0,_types_BigCommerce_BCCart__WEBPACK_IMPORTED_MODULE_2__.assertBCCarts)([
                            cart
                        ]);
                        return _ctx.abrupt("return", cart);
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", null);
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    9
                ]
            ]);
        }));
        return function(lineItem) {
            return _ref.apply(this, arguments);
        };
    }();
};
var createCartWithSingleLineItem = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_codebuild_output_src3265067168_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(lineItem) {
        var response, cart;
        return _codebuild_output_src3265067168_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .log */ .cM)("Creating new cart with", {
                        body: {
                            lineItems: [
                                {
                                    productId: lineItem.productId,
                                    quantity: lineItem.quantity,
                                    variantId: lineItem.variantId
                                }
                            ]
                        }
                    });
                    _ctx.next = 4;
                    return axios__WEBPACK_IMPORTED_MODULE_5___default().post("/api/storefront/carts?include=lineItems.physicalItems.options", {
                        lineItems: [
                            lineItem
                        ]
                    });
                case 4:
                    response = _ctx.sent;
                    cart = response.data;
                    (0,_types_BigCommerce_BCCart__WEBPACK_IMPORTED_MODULE_2__.assertBCCarts)([
                        cart
                    ]);
                    return _ctx.abrupt("return", cart.id);
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .error */ .vU)("Failed to create cart with line Item");
                    return _ctx.abrupt("return", null);
                case 14:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }));
    return function createCartWithSingleLineItem(lineItem) {
        return _ref.apply(this, arguments);
    };
}();
var attemptToRecreateCart = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_codebuild_output_src3265067168_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(originalLineItems) {
        var cartId, remainingLineItems;
        return _codebuild_output_src3265067168_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    cartId = null;
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return createCartWithSingleLineItem(originalLineItems[0]);
                case 4:
                    cartId = _ctx.sent;
                    _ctx.next = 10;
                    break;
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](1);
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .log */ .cM)("we failed to add the first item to the cart");
                case 10:
                    remainingLineItems = originalLineItems.slice(1);
                    if (!(!cartId && originalLineItems.length > 1)) {
                        _ctx.next = 16;
                        break;
                    }
                    _ctx.next = 14;
                    return attemptToRecreateCart(remainingLineItems);
                case 14:
                    _ctx.next = 28;
                    break;
                case 16:
                    if (!cartId) {
                        _ctx.next = 27;
                        break;
                    }
                    _ctx.prev = 17;
                    _ctx.next = 20;
                    return Promise.all(remainingLineItems.map(addSingleLineItemToCart(cartId)));
                case 20:
                    _ctx.next = 25;
                    break;
                case 22:
                    _ctx.prev = 22;
                    _ctx.t1 = _ctx["catch"](17);
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .log */ .cM)("some of the items failed to be readded to the cart");
                case 25:
                    _ctx.next = 28;
                    break;
                case 27:
                    {
                        (0,_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .log */ .cM)("we failed to add any items to the cart");
                    }
                case 28:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                7
            ],
            [
                17,
                22
            ]
        ]);
    }));
    return function attemptToRecreateCart(originalLineItems) {
        return _ref.apply(this, arguments);
    };
}();
var recreateOrder = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_codebuild_output_src3265067168_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var order, ref, standardizeOrderFromResponse, standardizeAddressForBigC, ref1, originalProductsDistribution, originalLineItems, newCart, newLineItems, newConsignments, bigcResponse, newOrder;
        return _codebuild_output_src3265067168_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    order = param.order;
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .log */ .cM)("recoverAvailableShippingOptions START", {
                        order: order
                    });
                    _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z;
                    _ctx.next = 5;
                    return (0,_helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                        return [
                            Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 93239)),
                            Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 68203)), 
                        ];
                    });
                case 5:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 2);
                    standardizeOrderFromResponse = ref[0].standardizeOrderFromResponse;
                    standardizeAddressForBigC = ref[1].standardizeAddressForBigC;
                    _ctx.prev = 9;
                    ;
                    originalProductsDistribution = order.shipments.map(function(param) {
                        var lineItems = param.lineItems, shippingAddress = param.shippingAddress;
                        return {
                            lineItems: lineItems.map(function(param) {
                                var productId = param.productId, variantId = param.variantId, quantity = param.quantity;
                                return {
                                    productId: productId,
                                    variantId: variantId,
                                    quantity: quantity
                                };
                            }),
                            shippingAddress: shippingAddress
                        };
                    });
                    originalLineItems = order.cart.lineItems.map(function(param) {
                        var productId = param.productId, quantity = param.quantity, variantId = param.variantId;
                        return {
                            productId: productId,
                            quantity: quantity,
                            variantId: variantId
                        };
                    });
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .log */ .cM)({
                        originalProductsDistribution: originalProductsDistribution,
                        originalLineItems: originalLineItems
                    });
                    // Delete current cart
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .log */ .cM)(" Deleting cart", {
                        cart: order === null || order === void 0 ? void 0 : order.cart
                    });
                    _ctx.next = 17;
                    return deleteCart(order === null || order === void 0 ? void 0 : order.cart.id);
                case 17:
                    // Add Items to new cart
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .log */ .cM)("Creating a new cart with previous items", {
                        lineItems: originalLineItems
                    });
                    _ctx.next = 20;
                    return axios__WEBPACK_IMPORTED_MODULE_5___default().post("/api/storefront/carts", {
                        lineItems: originalLineItems
                    });
                case 20:
                    newCart = _ctx.sent.data;
                    (0,_types_BigCommerce_BCCart__WEBPACK_IMPORTED_MODULE_2__.assertBCCarts)(newCart);
                    newLineItems = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(newCart.lineItems.physicalItems);
                    newConsignments = originalProductsDistribution.map(function(param) {
                        var shippingAddress = param.shippingAddress, lineItems = param.lineItems;
                        return {
                            shippingAddress: standardizeAddressForBigC(shippingAddress),
                            lineItems: lineItems.map(function(param) {
                                var productId = param.productId, variantId = param.variantId, quantity = param.quantity;
                                var ref;
                                return {
                                    itemId: String((ref = newLineItems.find(function(p) {
                                        return p.productId === productId && p.variantId === variantId;
                                    })) === null || ref === void 0 ? void 0 : ref.id),
                                    quantity: quantity
                                };
                            })
                        };
                    });
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .log */ .cM)("Recreating consignments", {
                        newCart: newCart,
                        newLineItems: newLineItems,
                        newConsignments: newConsignments
                    });
                    _ctx.next = 27;
                    return axios__WEBPACK_IMPORTED_MODULE_5___default().post("/api/storefront/checkouts/".concat(newCart === null || newCart === void 0 ? void 0 : newCart.id, "/consignments?include=consignments.availableShippingOptions"), newConsignments);
                case 27:
                    _ctx.t3 = ref1 = _ctx.sent;
                    _ctx.t2 = _ctx.t3 === null;
                    if (_ctx.t2) {
                        _ctx.next = 31;
                        break;
                    }
                    _ctx.t2 = ref1 === void 0;
                case 31:
                    if (!_ctx.t2) {
                        _ctx.next = 35;
                        break;
                    }
                    _ctx.t4 = void 0;
                    _ctx.next = 36;
                    break;
                case 35:
                    _ctx.t4 = ref1.data;
                case 36:
                    bigcResponse = _ctx.t4;
                    (0,_types_BigCommerce_BCCheckout__WEBPACK_IMPORTED_MODULE_3__.assertBCCheckout)(bigcResponse);
                    _ctx.next = 40;
                    return standardizeOrderFromResponse({
                        bigcResponse: bigcResponse,
                        order: order
                    });
                case 40:
                    newOrder = _ctx.sent;
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .log */ .cM)("New standardized order", {
                        newOrder: newOrder
                    });
                    return _ctx.abrupt("return", {
                        newOrder: newOrder,
                        success: true
                    });
                case 45:
                    _ctx.prev = 45;
                    _ctx.t5 = _ctx["catch"](9);
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .error */ .vU)("recoverAvailableShippingOptions ERROR", _ctx.t5);
                case 48:
                    return _ctx.abrupt("return", {
                        success: false,
                        newOrder: null
                    });
                case 49:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                9,
                45
            ]
        ]);
    }));
    return function recreateOrder(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["default"] = (recreateOrder);


/***/ }),

/***/ 55780:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content":"LoadingModal_content__zUFSW","contentNoMessage":"LoadingModal_contentNoMessage__658Zz","progressCircle":"LoadingModal_progressCircle__yhn2g","ring":"LoadingModal_ring__gwWBV","spinTheRing":"LoadingModal_spinTheRing__0Gfge","logo":"LoadingModal_logo__5FvL4","overwriteModalZIndex":"LoadingModal_overwriteModalZIndex__bih9L"};

/***/ })

}]);